import React, { useState, useEffect } from "react";

import arcBridge from 'frontend/js/arcBridge';

export const AccountProfile = () => {
  const [loading, setLoading] = useState(true);
  const [customerRewardsStatus, setCustomerRewardsStatus] = useState(null);

  useEffect(() => {
    async function getCustomerRewardsProfile () {
      try {
        const rewardsProfile = await arcBridge.getCustomerRewards();
        if (rewardsProfile.success) {
          setCustomerRewardsStatus(rewardsProfile.results);
        }
      } catch (error) {
        console.error("Failed to fetch rewards profile", error);
      } finally {
        setLoading(false);
      }
    }
    getCustomerRewardsProfile();
  }, [])

  const getTierInfo = () => {
    if (!customerRewardsStatus) {
      return { status: "Silver" };
    }
  
    const tier = customerRewardsStatus.tier || "Silver";
    return {
      Silver: { status: "Silver"},
      Gold: { status: "Gold"},
      Platinum: { status: "Platinum"},
    }[tier];
  };

  const tierInfo = getTierInfo();
  const points = customerRewardsStatus?.points || 0;
  const rewardsBalance = (points / 100).toFixed(2);
  const baleBucks = points * 100;
  
  return (
    <div className="grid lg:grid-cols-2 lg:my-[64px]">
      <div className="flex flex-col my-6 lg:my-[0px]">
        <label className="mb-1 text-black uppercase bc">Rewards Balance</label>
        <h3>
          ${points}
          {/* <small className="ml-[4px] font-medium text-black blabel">or {baleBucks.toLocaleString()} Bale Bucks</small> */}
        </h3>
      </div>
      <div className="flex flex-col">
        <label className="mb-1 text-black uppercase bc">Rewards Tier</label>
        <div className="flex items-center">
          {loading ? (
            <span className="text-gray-400">Loading...</span>
          ) : (
            <>
              <h3
                className={
                  tierInfo.status === "Silver"
                    ? "text-[#A2A9AD]"
                    : tierInfo.status === "Gold"
                    ? "text-[#CDA176]"
                    : tierInfo.status === "Platinum"
                    ? "text-[#020202]"
                    : "text-[#54565A]"
                }
              >
                {tierInfo.status}
              </h3>
            </>
          )}
        </div>
      </div>
    </div>
  )
}

export default AccountProfile;